export { userStore } from './userStore'
export { routerStore } from './routerStore'
export { receiveCouponForLiveStore } from '@views/receiveCouponForLive/actor/store'

// store for most containers/shared
export * from '@shared/store'
export * from '@views/login/store/index'
export * from '@views/home/actor/store'
export * from '@views/mine/store'
export * from '@views/ordering/actor/store'
export * from '@views/integralMall/actor/store'
export * from '@views/home/actor/packageDetailStore'
export * from '@views/ordering/store.tsx'
export * from './storeFront'

// store for global
export * from '@src/containers/viewsG/home/actor/store'
export * from '@src/containers/viewsG/login/actor/store'
export * from '@src/containers/viewsG/register/actor/store'
export * from '@src/containers/viewsG/me/actor/store'
export * from '@src/containers/viewsG/myDevice/actor/store'
export * from '@src/containers/viewsG/billAddress/actor/store'
export * from '@src/containers/viewsG/suggest/actor/store'